/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
//
// Renderer for Platform Image Component
import { Image } from '@chakra-ui/react';
import { PlatformImageComponent } from '@karya/core';
import { ParsedParams } from '@karya/generic-task-react';

export function PlatformImageRenderer({ params }: { params?: ParsedParams<any> }) {
  const typedParams = params as ParsedParams<PlatformImageComponent> | undefined;
  const url = typedParams?.image ?? '/sample_image.jpg';
  return <Image src={url} />;
}
